import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faUser, faTachometerAltSlow, faCabinetFiling, faBalanceScaleRight, faAddressBook, faCogs, faChevronLeft,
  faChevronDoubleLeft, faChevronRight, faChevronDoubleRight, faPlus, faTags, faPencil, faTrash, faBooks,
  faUserLock, faAtomAlt, faUserFriends, faSlidersHSquare, faCog, faIdCardAlt, faShareAlt, faServer, faCrosshairs,
  faWindowRestore, faCheck, faChartLine, faFileChartLine, faSearch, faCalendarCheck, faTally, faChevronCircleDown,
  faChevronCircleUp, faExchange, faFunnelDollar, faPiggyBank, faCloudDownload, faCoins
} from '@fortawesome/pro-light-svg-icons'

import {
  faSignalSlash
} from '@fortawesome/pro-solid-svg-icons'

import {
  faBell, faComments, faInfoCircle, faSignOutAlt, faThumbtack, faTimes, faLongArrowAltUp, faLongArrowAltDown,
  faUserTag, faLock, faCaretUp, faCaretDown, faBold, faItalic, faPaperPlane, faCommentAlt
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUser, faTachometerAltSlow, faCabinetFiling, faBalanceScaleRight, faAddressBook, faCogs, faBell,
  faComments, faInfoCircle, faSignOutAlt, faChevronLeft, faChevronDoubleLeft, faChevronRight, faChevronDoubleRight,
  faThumbtack, faTimes, faPlus, faTags, faPencil, faTrash, faBooks, faUserLock, faAtomAlt, faLongArrowAltUp,
  faLongArrowAltDown, faUserTag, faUserFriends, faSlidersHSquare, faCog, faIdCardAlt, faLock, faShareAlt, faCaretUp,
  faCaretDown, faServer, faPlus, faCrosshairs, faWindowRestore, faBold, faItalic, faPaperPlane, faCheck, faCommentAlt,
  faChartLine, faFileChartLine, faSignalSlash, faSearch, faCalendarCheck, faTally, faChevronCircleDown,
  faChevronCircleUp, faExchange, faFunnelDollar, faPiggyBank, faCloudDownload, faCoins)

Vue.component('fa-icon', FontAwesomeIcon)
